"use strict";
import React from "react";
import $ from "jquery";
import TypeAhead from "./ui/type_ahead";
var CustomerTypeAhead = React.createClass({
  search: function(name) {
    return Promise.resolve($.get("/api/customers", { filterTerms: name })).then(
      function(data) {
        const results = data.customers;
        return results;
      }
    );
  },
  render: function() {
    return /* @__PURE__ */ React.createElement(
      TypeAhead,
      {
        "data-component": "CustomerTypeAhead",
        remoteSearch: this.search,
        display: this.customerDisplay,
        readOnly: this.props.readOnly,
        placeHolder: "Customer Name",
        className: "customer-setter__typeahead",
        isDroppable: true,
        selectedItem: this.props.customer,
        onSelectItem: this.props.onSelectCustomer,
        onClearSelectedItem: this.props.onClearCustomer
      }
    );
  },
  customerDisplay: function(customer) {
    var html = customer.name;
    if (customer.account_number) {
      html += " - # ";
      html += customer.account_number;
    }
    return html;
  }
});
export default CustomerTypeAhead;
